module.exports = __webpack_public_path__ + "double-r6siege-ru-desktop.jpg";